var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isDocx, isPdf, isDocxDocument, isPdfDocument } from 'shared/domains/documents';
import { useDocxToPdf } from './useDocxToPdf';
import { useGetDocumentData } from './useGetDocumentData';
import { useHtmlToPdf } from './useHtmlToPdf';
export const useGetPdf = () => {
    const [docxToPdf] = useDocxToPdf();
    const [htmlToPdf] = useHtmlToPdf();
    const { getDocumentData } = useGetDocumentData();
    const getPdf = (companyId, documentId) => __awaiter(void 0, void 0, void 0, function* () {
        const document = yield getDocumentData(documentId);
        if (!document) {
            throw Error('Failed to retrieve document data');
        }
        if (isDocxDocument(document)) {
            const docxFile = document.files.find(isDocx);
            if (docxFile) {
                try {
                    return docxToPdf({
                        companyId,
                        path: docxFile.path,
                        size: docxFile.size,
                        mimeType: docxFile.type,
                    });
                }
                catch (_a) {
                    throw Error('No docx file attached to docx view');
                }
            }
        }
        if (isPdfDocument(document)) {
            const pdfFile = document.files.find(isPdf);
            if (pdfFile) {
                try {
                    return pdfFile;
                }
                catch (_b) {
                    throw Error('No pdf file attached to pdf view');
                }
            }
        }
        return htmlToPdf(documentId, document.name);
    });
    return { getPdf };
};
